﻿import { Component, EventEmitter, Input, Output, HostListener } from '@angular/core';

const ESCAPE_KEYCODE = 27;

@Component({
    selector: 'modal',
    templateUrl: 'modal.component.html',
    styleUrls: ['modal.component.scss'],
})
export class ModalComponent {

  // constructor(activeModal: NgbActiveModal) {}
    @Input() header;
    @Input() hidden = true;
    @Input() large = false;
    @Input() hasFooterAction = true;

    @Output() dismiss: EventEmitter<boolean> = new EventEmitter();
    @Output() save: EventEmitter<boolean> = new EventEmitter();

    @HostListener('document:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        if (event.keyCode === ESCAPE_KEYCODE) {
            this.dismissClicked();
        }
    }

    saveClicked() {
        this.save.emit(true);
    }

    dismissClicked() {
        this.dismiss.emit(false);
    }
}
